<!--
 * @Descripttion: 
 * @version: 
 * @Author: your name
 * @Date: 2025-02-18 15:22:46
 * @LastEditors: your name
 * @LastEditTime: 2025-02-18 15:40:31
-->
<template>
  <div id="app" class="app">
    <transition name="component-fade" mode="out-in">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
    </transition>

    <transition name="component-fade" mode="out-in">
      <router-view v-if="!$route.meta.keepAlive"></router-view>
    </transition>
  </div>
</template>
<script>
// import Vue from "vue";


export default {
  name: "App",
  data() {
    return {
    };
  },
  mounted() {},
  methods: {}
};
</script>
<style lang="less">

/* [v-cloak] {
  display: none;
} */
body,
html {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}
.mint-toast-text {
  font-size: 28px !important; /* 设置您想要的字体大小 */
}
/* .mint-toast {
  font-size: 100px !important;
} */
.mytoast {
  z-index: 100000001 !important;
  font-size: 28px !important; /* 设置您想要的字体大小 */
}
</style>
